import { commonService } from "../../utils/commonService";
import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import WeatherComonent from "../CommonComponent/WeatherComonent";
import { useSelector } from "react-redux";
import Non_WidgetDetailModal from "./NonWidgetDetailModal";
import infoIcon from "../../Assets/Images/Action Icons/infoIcon..svg";
function WeatherPage() {
    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    return (
        <>
            <div className="weather-page-main">
                <div id={commonService.generateGlobalClickTrackerID("WeatherPage", "div-onclick", "")} className="cursorPointer heading-menu-btns" style={{ position: "absolute", right: "15px", top: "10px", width: "auto" }}
                    onClick={() => {
                        setWidgetModal(true);
                    }}>
                    <img src={infoIcon} alt="graphIcon" />
                </div>
                {propertyDetailFromRTK ? (
                    propertyDetailFromRTK?.geolocation ? (
                        <Container fluid>
                            <Row>
                                <Col xl={12}>
                                    <div className="ProspectDashboardTitleWraper  d-flex justify-content-between  align-items-center mb-4">
                                        <h2>
                                            Dashboard- <span className="tab-title-main">Weather</span>
                                        </h2>
                                    </div>
                                </Col>
                            </Row>
                            <WeatherComonent />
                        </Container>
                    ) : (
                        <Container>
                            <div className="d-flex justify-content-center">
                                <h5>Please add location in configuration</h5>
                            </div>
                        </Container>
                    )
                ) : (
                    <Container>
                        <div className="d-flex justify-content-center">
                            <h5>Please Select Property</h5>
                        </div>
                    </Container>
                )}
                {widgetModal && (
                    <Non_WidgetDetailModal
                        showModal={widgetModal}
                        closeModal={closeWidgetModal}
                        non_widgetname={"Weather"}
                    />
                )}
            </div>
        </>
    );
}

export default WeatherPage;
